(function () {
    "use strict";

    // @ngInject
    function NetworkBannersContainerDirectiveControllerFunc($scope, $injector,
                                                            OnboardingService, AbTestService, Enums) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkBannersContainerDirectiveController';
        this.OnboardingService = OnboardingService;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
    }

    var NetworkBannersContainerDirectiveController = Class(Controllers.BaseController, {
        constructor: NetworkBannersContainerDirectiveControllerFunc,

        openIntakeForm: function openIntakeForm() {
            this.OnboardingService.openInProductIntakeForm(this.Enums.IntakeFormSource.communityOpsAd);
        },

    });

    function NetworkBannersContainerDirective() {
        return {
            scope: {
                banners: '<'
            },
            templateUrl: 'angular/app/modules/network/features/feed/network_feed_banners_container_directive_template.html',
            controller: NetworkBannersContainerDirectiveController,
            controllerAs: 'networkBannersContainerVm',
            bindToController: true
        };
    };

    angular.module('honeybook.network.features.banners', [])
        .controller('NetworkBannersContainerDirectiveController', NetworkBannersContainerDirectiveController)
        .directive('hbNetworkBannersContainer', NetworkBannersContainerDirective);

}());
